import React from 'react';
import { motion } from 'framer-motion';
import { trackEvent } from '../lib/metaPixel';
export function FinalCTA() {
  return <section className="py-16 sm:py-20 relative overflow-hidden bg-teal-dark/20 border-t border-teal/20" data-id="element-44">
      {/* Subtle vignette/glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(31,58,52,0.4)_0%,rgba(11,13,12,1)_100%)]" data-id="element-45" />

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-47">
          <h2 className="font-serif text-5xl sm:text-6xl text-ivory mb-8 leading-[1.1]" data-id="element-48">
            You Are Not Weak.
            <br data-id="element-49" />
            <span className="text-gold/90" data-id="element-50">Your Brain Was Overstimulated.</span>
          </h2>

          <p className="text-xl sm:text-2xl text-ivory/80 font-light mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-51">
            UNHOOKED helps you understand what happened to your mind — and how
            to finally regain control.
          </p>

          <a href="https://vitalyforms.com/cart/50274454110428:1" onClick={() => trackEvent('AddToCart', {
          content_name: 'UNHOOKED Ebook',
          content_ids: ['50274454110428'],
          content_type: 'product',
          value: 14.99,
          currency: 'USD'
        })} className="inline-block bg-ivory text-charcoal hover:bg-white transition-all duration-300 px-12 py-5 rounded-md font-medium text-lg tracking-wide mb-6 shadow-glow-gold hover:scale-[1.02]" data-id="element-52">
            Read UNHOOKED Now
          </a>

          <div className="text-xs sm:text-sm tracking-[0.15em] uppercase text-ivory/50" data-id="element-53">
            Instant Digital Access • Private Purchase • 30-Day Guarantee
          </div>
        </motion.div>
      </div>
    </section>;
}